/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Хелпер для определения браузеров и версий
   */
  app.helpers.BrowserDetectHelper = {

    /**
     * Получает набор конфигураций для разных типов устройств из конфига.
     * @returns {Object} версии для различных типов устаревших браузеров
     */
    getCurrentOsVersions: function () {
      var isDesktopBrowser;
      if (!app.isDesktop) {
        isDesktopBrowser = $('.old-browser-content').data('device-desktop');
      } else {
        isDesktopBrowser = app.isDesktop;
      }

      switch (bowser.osname) {
        case 'Android':
          return app.OLD_BROWSER_VERSIONS.mobileAndroid;
        case 'iOS':
          return app.OLD_BROWSER_VERSIONS.mobileIOS;
        default:
          return isDesktopBrowser ? app.OLD_BROWSER_VERSIONS.desktop : app.OLD_BROWSER_VERSIONS.mobile;
      }
    },

    /**
     * Получает информацию о браузерах Opera mini и Opera mobile и их версиях,
     * возвращает информацию о поддержке браузера
     * @returns {Object}/false данные о браузере или false если такие барузеры не найдены
     */
    getOperaMiniOrMobileOptions: function () {
      var ua = navigator.userAgent,
        tem,
        browserOptions,
        configVersion;
      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        if (ua.indexOf('Opera Mini') > -1) {
          browserOptions = {name: 'operamini', version: tem[1]};
          if (bowser.osname === 'Android') {
            configVersion = app.OLD_BROWSER_VERSIONS.mobileAndroid.operamini;
          }
          if (bowser.osname === 'iOS') {
            configVersion = app.OLD_BROWSER_VERSIONS.mobileIOS.operamini;
          }
        } else if (ua.indexOf('Opera Mobi') > -1) {
          browserOptions = {name: 'operamobi', version: tem[1]};
          if (bowser.osname === 'Android') {
            configVersion = app.OLD_BROWSER_VERSIONS.mobileAndroid.operamobile;
          }
        }
        if (configVersion && browserOptions.version >= parseInt(configVersion)) {
          browserOptions.isUnsupported = false;
        } else {
          if (browserOptions && browserOptions.name) {
            browserOptions.isUnsupported = true;
          }
        }
        return browserOptions ? browserOptions : false;
      }
      return false;
    },
  };
})();

}.call(window));